import { render, staticRenderFns } from "./CivilCasesEdit.vue?vue&type=template&id=6434d2e6&"
import script from "./CivilCasesEdit.vue?vue&type=script&lang=js&"
export * from "./CivilCasesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports